import React from 'react';
import { styled } from '@linaria/react';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Divider } from '@daedalus/atlas/Divider';
import { ContentWrapper } from '@daedalus/atlas/helpers/ContentWrapper';
import { Stack } from '@daedalus/atlas/helpers/Stack';
import { Room, RoomWithoutOffers } from '@daedalus/core/src/room/types/room';
import { ImageProvider } from '@daedalus/core/src/staticContent/types/ImageProvider';
import { RoomAmenities } from '../RoomAmenities';
import { RoomInfo } from '../RoomInfo';
import { SwipeGallery } from '../SwipeGallery';
import { RoomDescription } from './RoomDescription';
interface Props {
  room: Room | RoomWithoutOffers;
  isRtl?: boolean;
  imageProvider: ImageProvider;
  onGallerySwipe?: () => void;
  roomCardSlot?: React.ReactNode;
  userCountry: string;
}
const GalleryWrapper = /*#__PURE__*/styled('div')({
  name: "GalleryWrapper",
  class: "g1rrm0sd",
  propsAsIs: false
});
export const RoomDetailsOverlayContent = ({
  isRtl = false,
  room,
  imageProvider,
  onGallerySwipe,
  roomCardSlot = null,
  userCountry
}: Props) => {
  const {
    isMobile
  } = useDeviceLayout();
  const images = room.images.map(image => image.url);
  const hasDescription = room.description;
  const hasAmenities = room.amenities.length > 0;
  const hasRoomCardSlot = roomCardSlot;
  const dividedItems = [...(hasDescription ?
  // eslint-disable-next-line react/jsx-key
  [<RoomDescription description={room.description} />] : []),
  // eslint-disable-next-line react/jsx-key
  ...(hasAmenities ? [<RoomAmenities room={room} />] : []), ...(hasRoomCardSlot ? [roomCardSlot] : [])];
  return <div>
      {images.length > 0 && <GalleryWrapper>
          <SwipeGallery images={images} imageProvider={imageProvider} backgroundSize="cover" isRtl={isRtl} showPageNumber imageSize={isMobile ? 'mobileLarge' : 'extraLarge'} onSwipe={onGallerySwipe} hasDarkBackground={true} hasDarkGradient={true} showPaginationButtons={!isMobile} />
        </GalleryWrapper>}
      <ContentWrapper padding="s500" paddingY="s600">
        <RoomInfo room={room} userCountry={userCountry} hideAmenities />
      </ContentWrapper>
      <Divider sideMargin="s500" />
      <ContentWrapper padding="s500" paddingTop="s700" paddingBottom="s900">
        <Stack space="s700">
          {dividedItems.map((item, index) => <React.Fragment key={index}>
              {item}
              {index < dividedItems.length - 1 && <Divider />}
            </React.Fragment>)}
        </Stack>
      </ContentWrapper>
    </div>;
};

require("./RoomDetailsOverlayContent.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./RoomDetailsOverlayContent.tsx");